module.exports = __webpack_public_path__ + "img/align-justify.6ba9e0e0.svg";